// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"e43e275f","670":"48b5a5fd"}[chunkId] + ".chunk.css";
};